// eslint-disable-next-line no-restricted-globals
const global = typeof window === 'undefined' ? undefined || {} : window;

export { global as g };
